import config from 'config';
import { useState } from 'react';
import { useAppDispatch } from 'reducer';
import { errorAlert, successAlert } from 'reducer/slices/alertSlice';
import { hideLoading, showLoading } from 'reducer/slices/loadingSlice';
import { hidePopup } from 'reducer/slices/popupSlice';
import gather from 'tools/gather';

const ChangeToken = ({ type }: { type: 0 | 1 }) => {
  const dispatch = useAppDispatch();
  const [token, setToken] = useState('');

  const submit = async () => {
    dispatch(showLoading());

    const result = await gather(`${config.apiUrl}/v1/admin/mtoken`, true).put({
      type: type,
      token: token,
    });

    if (result.code === 200) {
      dispatch(hidePopup());
      dispatch(successAlert('Done!'));
    } else {
      dispatch(errorAlert(result.message ?? 'Not connected to server'));
    }

    dispatch(hideLoading());
  };

  return (
    <div className='login'>
      <div className='inputLogin'>
        <span>Token === MANAGE {type}</span>
        <input type='text' onChange={(e) => setToken(e.target.value)} />
      </div>
      <div className='submit' onClick={() => submit()}>
        Submit
      </div>
    </div>
  );
};

export default ChangeToken;
